import React from "react";

export const Arrow = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="56px"
      height="56px"
      viewBox="0 0 1570.000000 1569.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,1569.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M7550 15680 c-1832 -78 -3495 -742 -4880 -1948 -171 -149 -553 -529
-696 -692 -847 -967 -1430 -2072 -1733 -3285 -179 -715 -250 -1386 -230 -2163
38 -1447 497 -2880 1314 -4102 1012 -1514 2515 -2631 4246 -3154 976 -295
2004 -397 3021 -301 1466 139 2857 686 4026 1583 948 727 1714 1654 2245 2717
463 927 723 1873 809 2940 17 211 17 931 0 1130 -45 530 -117 965 -234 1415
-496 1910 -1712 3579 -3383 4642 -1115 710 -2402 1128 -3715 1207 -256 16
-576 20 -790 11z m825 -420 c1370 -100 2682 -571 3781 -1357 362 -259 620
-478 934 -793 386 -385 651 -705 936 -1131 644 -961 1053 -2053 1198 -3199 50
-395 70 -972 47 -1365 -77 -1324 -495 -2577 -1226 -3680 -1229 -1856 -3242
-3072 -5445 -3289 -376 -37 -847 -47 -1203 -26 -2105 129 -4044 1137 -5364
2790 -853 1068 -1398 2362 -1563 3710 -41 339 -53 543 -53 910 0 471 26 806
94 1220 294 1781 1206 3365 2606 4528 677 561 1489 1016 2330 1303 649 221
1326 350 2041 389 185 10 688 4 887 -10z"
        />
        <path
          d="M9819 9317 c-59 -31 -100 -92 -107 -155 -9 -100 -20 -87 511 -619
l492 -493 -3113 0 -3112 0 0 -205 0 -205 3110 0 c1711 0 3110 -3 3110 -7 0 -5
-217 -224 -481 -488 -264 -264 -489 -497 -500 -517 -27 -52 -24 -113 7 -176
42 -85 139 -127 234 -102 41 11 106 73 724 688 463 462 684 690 697 717 24 51
24 129 0 174 -24 45 -1356 1376 -1397 1396 -48 23 -123 19 -175 -8z"
        />
      </g>
    </svg>
  );
};
